import { pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  typedJsonb,
  JsonRootData,
} from '../common/utils'

export const formSubmissions = pgTable(
  'form_submissions',
  {
    ...getBaseFields(),
    formId: text(),
    source: text(),
    data: typedJsonb<JsonRootData>('data').notNull(),
    utmParams: typedJsonb<JsonRootData>('utm_params'),
    ipAddress: text(),
    userAgent: text(),
  },
  (table) => getBaseIndexes('form_submissions', table),
)
